import { render, staticRenderFns } from "./VipContractManager.vue?vue&type=template&id=35c6f916&scoped=true&"
import script from "./VipContractManager.vue?vue&type=script&lang=js&"
export * from "./VipContractManager.vue?vue&type=script&lang=js&"
import style0 from "./VipContractManager.vue?vue&type=style&index=0&id=35c6f916&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6f916",
  null
  
)

export default component.exports